import * as React from 'react'

import get from 'lodash-es/get'

import { getCurrentSiteDomain } from '../../../../common/utils/sites'
import { getConfigBySite } from '../../../../config/sites'
import { config } from '../../../../common/config'
import createAutoSuggestDataContainer from '../../../components/autosuggest/autoSuggestDataContainer'
import createAutoSuggestLogicContainer from '../../../components/autosuggest/autoSuggestLogicContainer'
import AutoSuggest from '../../../v0/components/autosuggest/autosuggest'
import CategoryTilesBlock from '../../../components/homePage/categoryTilesBlock'
import ElementsItemsBlock from '../../../components/homePage/elementsItemsBlock'
import ItemsShowcaseBlock from '../../../components/homePage/itemsShowcaseBlock'
import FeaturedAuthorBlock from '../../../components/homePage/featuredAuthorBlock'
import FreeItemsBlock from '../../../components/homePage/freeItemsBlock'
import SearchHeaderBlock from '../../../components/homePage/searchHeaderBlock'
import getElementsDataForSite from '../homePageElementsBlockData'
import getBestSellersData from '../data/bestSellers'
import categoryTilesData from '../data/categoryTiles'
import getValuePropositionData from '../data/valueProposition'
import getQualityItemsData from '../data/qualityItems'
import popularSearchesData from '../homePagePopularSearchesData'
import NewestItemsBlock from '../../../components/homePage/newestItemsBlock/newestItemsBlock'
import FeatureContainer from '../../../containers/feature'
import ValuePropositionBlock from '../../../components/homePage/valuePropositionBlock/valuePropositionBlock'
import SVGSpriteWrapper from '../../../components/svgSpriteWrapper'
import QualityItemsBlock from '../../../components/homePage/qualityItemsBlock/qualityItemsBlock'

import * as autoSuggestStyles from '../../../v0/components/autosuggest/themes/homepage.newdesign.module.css'
import * as styles from '../homePage.module.css'

import {
  IDispatchProps,
  IStateProps
} from '../../../containers/homePageContainer/createHomePageContainer'

const AutoSuggestContainer = createAutoSuggestDataContainer(
  createAutoSuggestLogicContainer(AutoSuggest)
)

interface ITemplateInterface {
  siteCopyData: any
}

type Props = ITemplateInterface & IDispatchProps & IStateProps

const RedesignedTemplate = ({
  currentSite,
  metadata,
  categories,
  newestItemsData,
  featuredItems,
  freeItems,
  featuredAuthor,
  fetchNewestItemsByCategory,
  reportItemClick,
  makeSearchLink
}: Props) => {
  return (
    <SVGSpriteWrapper
      spriteURL={`${
        config.assets.PUBLIC_PATH
      }/images/home-page/new-design/sprites-${currentSite}-v2.svg`}
    >
      <div className={styles.searchHeaderSection} data-version={'redesigned'}>
        <SearchHeaderBlock
          currentSite={currentSite}
          data={popularSearchesData[currentSite]}
          title={get(metadata, 'search_area.heading')}
        >
          <AutoSuggestContainer
            inputName="term"
            value=""
            placeholder={getConfigBySite(
              currentSite,
              'home_search_placeholder'
            )}
            currentSite={currentSite}
            locationParams={{}}
            makeSearchLink={makeSearchLink}
            styles={autoSuggestStyles}
            showCategories={true}
          />
        </SearchHeaderBlock>
      </div>

      <FeatureContainer name="homepageNewDesignPhase2">
        <CategoryTilesBlock {...categoryTilesData} currentSite={currentSite} />
      </FeatureContainer>

      <FeatureContainer name="homepageNewDesignPhase2">
        <QualityItemsBlock {...getQualityItemsData()} />
      </FeatureContainer>

      {metadata && (
        <ItemsShowcaseBlock
          cta={{ url: '/feature', title: 'View all featured themes' }}
          data={featuredItems}
          blockName="Featured Items"
          title="Featured themes"
          subtitle={metadata.featured_items.sub_heading}
        />
      )}

      <FeatureContainer name="homepageNewDesignPhase2">
        <ValuePropositionBlock {...getValuePropositionData()} />
      </FeatureContainer>

      {newestItemsData.items && metadata && (
        <NewestItemsBlock
          title={metadata.newest_items.heading}
          subtitle={metadata.newest_items.sub_heading}
          currentSite={currentSite}
          data={newestItemsData.items}
          cta={{
            title: 'View more new items',
            urlSearchParams: { sort: 'date' }
          }}
          categories={categories}
          fetchNewestItemsByCategory={fetchNewestItemsByCategory}
          itemsCategory={newestItemsData.itemsCategory}
          itemsPendingCategory={newestItemsData.itemsPendingCategory}
          loadingCachedCategory={newestItemsData.loadingCachedCategory}
        />
      )}

      {metadata && featuredAuthor.author && (
        <FeaturedAuthorBlock
          data={featuredAuthor.matches}
          title="Featured Author"
          author={featuredAuthor.author}
          subtitle={metadata.featured_author.sub_heading}
          cta={{
            title: 'View portfolio',
            url: `//${getCurrentSiteDomain(currentSite)}${
              featuredAuthor.author.profile_path
            }`
          }}
        />
      )}

      <FeatureContainer name="homepageNewDesignPhase2">
        <ItemsShowcaseBlock {...getBestSellersData()} />
        <ElementsItemsBlock
          {...getElementsDataForSite(currentSite)}
          reportItemClick={reportItemClick}
          currentSite={currentSite}
        />
      </FeatureContainer>

      {freeItems && metadata && (
        <FreeItemsBlock
          data={freeItems}
          title={metadata.free_items.heading}
          subtitle={metadata.free_items.sub_heading}
          reportItemClick={reportItemClick}
        />
      )}
    </SVGSpriteWrapper>
  )
}

export default RedesignedTemplate
